
<div>
    <div class="pl-3">
        <v-expansion-panels
            v-if ="groups"
            focusable
            accordion
        >
            <v-expansion-panel v-for="(group,index) in groups" :key="index">
                <v-expansion-panel-header
                    hide-actions
                    style="min-height: 35px;"
                >
                    {{ group.name }}
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <v-list-item class="pa-0  pt-0 pb-0 ml-0" v-for="importDefinition in group.importDefinitions" :key="importDefinition.id" link @click="onImportDefinition(importDefinition)">

                        <v-list-item-title  class="pr-0 ml-0 v-flex"  style="font-size: 14px; font-weight: 400; padding-left: 0px; padding-top: 0!important; padding-bottom: 0!important;" >
                            <div style="font-size: 38px; padding-left: 12px;">&#8227;</div>
                            <div style="padding-left: 4px; padding-top: 12px;">{{ importDefinition.name }}</div>
                        </v-list-item-title>

                    </v-list-item>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>
    </div>
</div>
